import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { registerStaticTranslations } from './translations/registerStaticTranslations';

// Initialize i18next with minimal config; resources are registered by our loader.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [
      'en', 'es', 'fr', 'de', 'it', 'pt', 'pt-BR', 'pt-PT', 'ru', 'ja', 'ar', 'ko', 'zh', 'zh-CN', 'zh-TW', 'da', 'tr', 'hr'
    ],
    ns: ['static'],
    defaultNS: 'static',
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });

// Register bundled static translations (screen-specific JSONs)
registerStaticTranslations(i18n);

export default i18n;


